import Call from '../Call';
import {objToQs} from '../Utils';

const ZeroPark = {
    get(filters) {
        return Call(`zeroPark?${objToQs(filters)}`);
    },

    getSubid() {
        return Call(`zeroPark/subid`);
    }
};

export default ZeroPark;


// WEBPACK FOOTER //
// ./src/services/API/components/ZeroPark.js